import { render, staticRenderFns } from "./UniMakerView.vue?vue&type=template&id=db1fd5ee&"
import script from "./UniMakerView.vue?vue&type=script&lang=ts&"
export * from "./UniMakerView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports